
















































import { UserModule } from '@/store/modules/user';
import ReturnBtn from '@/components/Common/SubmitBtn.vue';
import { Component, Vue, Prop, ModelSync } from 'vue-property-decorator';
import { getCurrentDateTime } from "@/utils/function_utils";
import { getAgentBdContactInfoApi } from '@/api/index';

@Component({
  name: 'submissionConfirmDialog',
  components: {
    ReturnBtn,
  }
})
export default class extends Vue {
  @ModelSync('dialogConfirmVisible', 'changeVisible', { type: Boolean }) public value!: boolean;

  @Prop() public submitDateTime!: string;
  @Prop() public readonly isDifferentialSubmit!: boolean;

  get submitter() {
    return UserModule.name;
  }

  get dateTime() {
    return getCurrentDateTime(this.submitDateTime);
  }

  public contactInfo = {
    email: '',
    phone: '',
    mobileAreaCode: '',
  }

  public mounted() {
    this.getAgentBdContactInfo();
  }

  public async getAgentBdContactInfo() {
    try {
      const { data } = await getAgentBdContactInfoApi();
      this.contactInfo = data.data;
    } catch(err) {
      //
    }
  }

  public handleReturn() {
    this.$emit('changeVisible', false);
  }

  public toDealWith() {
    this.handleReturn();
    this.$emit('toSettlingTab');
  }
}
